import React from "react";
import { Button, Checkbox, Label, TextInput } from "flowbite-react";
import { Textarea } from "flowbite-react";
export default function Contact() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-100 ">
      <div className="flex w-full rounded bg-white p-10 shadow-md ">
        {/* Left Column: Contact Form */}

        <div className="flex-1 bg-white p-8">
          <h2 className="mb-4 text-center text-3xl font-semibold">
            Liên hệ qua mail
          </h2>
          <form className="flex flex-col gap-4">
            <div>
              <div className="mb-2 block">
                <Label htmlFor="name" value="Your name" />
              </div>
              <TextInput
                id="name"
                type="text"
                placeholder="John Doe"
                required
              />
            </div>
            <div>
              <div className="mb-2 block">
                <Label htmlFor="email" value="Your email" />
              </div>
              <TextInput
                id="email"
                type="email"
                placeholder="name@example.com"
                required
              />
            </div>
            <div>
              <div className="mb-2 block">
                <Label htmlFor="message" value="Your message" />
              </div>
              <Textarea
                id="message"
                placeholder="Type your message here..."
                required
                rows={4}
              />
            </div>
            <Button type="submit">Gửi tin nhắn</Button>
          </form>
        </div>

        {/* Right Column: Text */}
        <div className="flex-1 bg-gray-50 p-8">
          <h2 className="mb-4 text-center text-2xl font-semibold">
            Liên hệ chúng tôi
          </h2>
          <p className="mb-4 text-gray-700">
            wi_sol coffee luôn luôn sẵn sàng lắng nghe những góp ý của quý khách
            hàng, dù là một câu hỏi, một ý kiến hay các soulmates của chúng mình
            cần người tư vấn, hỗ trợ thì wi_sol chúng tớ vẫn luôn ở ngay đây đợi
            các cậu!
          </p>
          <p className="mb-4 text-gray-700">
            Các tri kỉ có thể ghé thăm chúng tớ tại:
            <br />
            <strong>Wi_sol Coffee </strong>
            <br />
            188 Phan Văn Trị, Phường 12
            <br />
            Quận Bình Thạnh, TP. Hồ Chí Minh
          </p>
          <p className="mb-4 text-gray-700">
            Giờ mở cửa
            <br />
            Monday - Friday: 7:00 AM - 9:00 PM
            <br />
            Saturday - Sunday: 7:00 AM - 10:00 PM
          </p>
          <p className="mb-4 text-gray-700">
            Thông tin liên hệ:
            <br />
            Phone: 0896320894
            <br />
            Email: contact@wisol.com
          </p>
          <p className="text-gray-700">
            Theo dõi Wi_sol Coffee trên các nền tảng mạng xã hội như: Fanpage
            Facebook, Instagram..... để có thể nhận được nhiều ưu đãi lớn khi
            ghé thăm quán của chúng mình nhé!
          </p>
        </div>
      </div>
    </div>
  );
}
